import {
  getDiscounts,
  deleteDiscount,
  discountShow,
  updateDiscount,
  createDiscount
} from '../../api/discount'
import { Message } from 'element-ui'
import router from '../../router'

const state = {
  discounts: [],
  meta: {},
  discountShow: {}
}

const getters = {
  getDiscounts: state => state.discounts,
  getDiscountMeta: state => state.meta,
  getDiscountShow: state => state.discountShow
}

const mutations = {
  SET_DISCOUNTS: (state, payload) => {
    state.discounts = payload.data
    state.meta = payload.meta
  },
  SET_DISCOUNT_SHOW: (state, payload) => {
    state.discountShow = payload
  },
  ADD_DISCOUNT: (state, payload) => {
    state.discounts.push(payload)
  },
  REMOVE_DISCOUNT: (state, id) => {
    const index = state.discounts.findIndex(discount => discount.id === id)
    state.discounts.splice(index, 1)
  },
  UPDATE_DISCOUNT: (state, payload) => {
    const index = state.discounts.findIndex(discount => discount.id === payload.id)
    state.discounts.splice(index, 1, payload)
  }
}

const actions = {
  getDiscounts: ({commit}, params) => {
    getDiscounts(params).then(resp => {
      commit('SET_DISCOUNTS', resp)
    }).catch(err => console.log(err))
  },
  deleteDiscount: ({commit, dispatch}, id) => {
    deleteDiscount(id).then(r => {
      commit('REMOVE_DISCOUNT', id)

      Message({
        message: 'Discount has been deleted',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
    })
  },
  discountShow: ({commit, dispatch}, idUser) => {
    discountShow(idUser).then(r => {
      commit('SET_DISCOUNT_SHOW', r.data)
    }).catch(err => {
      console.dir(err)
      if (err.response.status === 404) {
        console.log(router.push({name: 'not-found'}))
      }
    })
  },
  clearCurrentDiscount: ({commit}) => {
    commit('SET_DISCOUNT_SHOW', {} )
  },
  updateDiscount: ({commit}, payload) => {
    updateDiscount(payload.id, payload).then(r => {
      commit('UPDATE_DISCOUNT', r.data)

      Message({
        message: 'Data saved',
        type: 'success',
        duration: 5 * 1000,
      })
    }).catch(err => console.dir(err))
  },
  createDiscount: ({commit}, payload) => {
    return new Promise((resolve, reject)=>{
      createDiscount(payload).then(resp => {
        commit('ADD_DISCOUNT', resp.data)
        resolve(resp)
      }).catch(err=> reject(err))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
